(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("survey-core"), require("survey-creator-core"), require("survey-knockout-ui"), require("knockout"));
	else if(typeof define === 'function' && define.amd)
		define("survey-creator-knockout", ["survey-core", "survey-creator-core", "survey-knockout-ui", "knockout"], factory);
	else if(typeof exports === 'object')
		exports["survey-creator-knockout"] = factory(require("survey-core"), require("survey-creator-core"), require("survey-knockout-ui"), require("knockout"));
	else
		root["SurveyCreator"] = factory(root["Survey"], root["SurveyCreatorCore"], root["SurveyKnockout"], root["ko"]);
})(this, (__WEBPACK_EXTERNAL_MODULE_survey_core__, __WEBPACK_EXTERNAL_MODULE_survey_creator_core__, __WEBPACK_EXTERNAL_MODULE_survey_knockout_ui__, __WEBPACK_EXTERNAL_MODULE_knockout__) => {
return 